export function isLogin(value) {
    return !localStorage.getItem(value);
}
